import { useReportsClient } from "../ReportsClientContext";
import { useReport } from "../useReport";

/** « En direct » polls this often; calls (dials, outcomes) also refresh it through realtime (useLiveRefresh). */
export const LIVE_REFRESH_MS = 15_000;

/** public.gavion_live_sessions, polled. Shared by the report page and the Team dashboard card. */
export const useLiveSessions = (refetchMs = LIVE_REFRESH_MS) => {
  const client = useReportsClient();
  return useReport(["live_sessions"], () => client.liveSessions(), {
    refetchInterval: refetchMs,
  });
};
